<div class="module fadeview" *ngIf="moduleUrl && guid">
  <iframe #module [src]="moduleUrl | safe" id="{{ guid }}" width="100%" height="90%" zoom="false"
    frameborder="0"></iframe>
</div>